var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperplane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6375 0.572562C17.4161 0.439721 17.1836 0.439721 16.94 0.572562L0.334871 10.27C0.0913284 10.425 -0.0193727 10.6464 0.00276754 10.9342C0.0249078 11.1999 0.168821 11.3881 0.434503 11.4988L5.71495 13.6574L6.87731 17.9748C6.92159 18.1076 6.99908 18.2294 7.10978 18.3401C7.22048 18.4287 7.35332 18.4729 7.5083 18.4729H7.57473C7.79613 18.4508 7.97325 18.3512 8.10609 18.174L10.0987 15.484L15.6116 17.7091C15.833 17.7977 16.0434 17.7866 16.2426 17.6759C16.4419 17.543 16.5526 17.3659 16.5747 17.1445L17.9363 1.23677C17.9806 0.948946 17.881 0.727544 17.6375 0.572562ZM5.881 12.2294L2.19465 10.7349L13.4862 4.15928L5.881 12.2294ZM12.7887 6.88252L8.37177 13.9563L8.30535 14.056L7.67435 15.6501L6.97694 13.1261L12.7887 6.88252ZM15.2463 16.0818L9.96587 13.9231L16.309 3.92681L15.2463 16.0818Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplane);
export default __webpack_public_path__ + "static/media/Paperplane.29dbb94d2c1efb0f6f0cee41105ec260.svg";
export { ForwardRef as ReactComponent };